import script from "./AircraftComponentsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AircraftComponentsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AircraftComponentsPage.vue?vue&type=style&index=0&id=3ad91f0b&lang=scss"

const __exports__ = script;

export default __exports__